export const SINGLE = 'single'
export const MARRIED = 'married'

export const ALL_MARITAL_STATUSES = [SINGLE, MARRIED] as const

export type MaritalStatus = (typeof ALL_MARITAL_STATUSES)[number]
